import { createBrowserRouter } from 'react-router-dom'
import { appRoutes } from '@presentation/navigation/routes'

export function createAppRouter() {
  return createBrowserRouter(appRoutes)
}

export const router = createAppRouter()
